import { useEffect, useState } from "react";

/** Media query als state (bijv. telefoon: andere bediening dan desktop). */
export function useMediaQuery(q: string) {
  const [match, setMatch] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const on = () => setMatch(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, [q]);
  return match;
}

/** Breekpunt telefoon (zie styles.css). */
export const PHONE_QUERY = "(max-width: 760px)";
